import {
  apiSlice,
  createClientV2MutationFn,
  createClientV2QueryFn,
} from 'store/slices/api';
import { parseQueryParams } from 'store/slices/utils';
import {
  ClientV2PATCHResponse,
  ClientV2POSTRequest,
  ClientV2POSTResponse,
  ListResponse,
  ClientV2PATCHRequest,
  QueryParams,
} from 'types/api';

import { CLIENT_V2_URLS } from 'store/slices/constants/clientV2';
import {
  PunchoutSessionPATCHSchema,
  PunchoutSessionPOSTSchema,
  PunchoutSessionSchema,
} from 'types/clientV2/punchout';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPunchoutSessions: builder.query<
      ListResponse<PunchoutSessionSchema>,
      QueryParams<PunchoutSessionSchema>
    >({
      queryFn: createClientV2QueryFn<
        ListResponse<PunchoutSessionSchema>,
        QueryParams<PunchoutSessionSchema>
      >((params) =>
        CLIENT_V2_URLS.PUNCHOUT_SESSIONS(
          parseQueryParams<PunchoutSessionSchema>(params)
        )
      ),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(
                ({ id }: PunchoutSessionSchema) =>
                  ({ type: 'PunchoutSession', id } as const)
              ),
              { type: 'PunchoutSession', id: 'LIST' },
            ]
          : [{ type: 'PunchoutSession', id: 'LIST' }],
    }),
    createPunchoutSessions: builder.mutation<
      ClientV2POSTResponse<PunchoutSessionSchema>,
      ClientV2POSTRequest<PunchoutSessionPOSTSchema>
    >({
      queryFn: createClientV2MutationFn<
        ClientV2POSTResponse<PunchoutSessionSchema>,
        ClientV2POSTRequest<PunchoutSessionPOSTSchema>
      >((payload) => ({
        url: CLIENT_V2_URLS.PUNCHOUT_SESSIONS(),
        method: 'POST',
        body: payload,
      })),
      invalidatesTags: [{ type: 'PunchoutSession', id: 'LIST' }],
    }),
    updatePunchoutSessions: builder.mutation<
      ClientV2PATCHResponse<PunchoutSessionSchema>,
      ClientV2PATCHRequest<PunchoutSessionPATCHSchema>
    >({
      query: (data) => ({
        url: CLIENT_V2_URLS.PUNCHOUT_SESSIONS(),
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: [{ type: 'PunchoutSession', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetPunchoutSessionsQuery,
  useLazyGetPunchoutSessionsQuery,
  useCreatePunchoutSessionsMutation,
  useUpdatePunchoutSessionsMutation,
  usePrefetch,
} = extendedApiSlice;
